export type Testimonial = {
  id: string;
  authorName: string;
  authorRole: string;
  duration: string;
  content: string;
  isAnonymous?: boolean;
  displayOrder: number;
};

export const testimonials: Testimonial[] = [
  {
    id: "tia",
    authorName: "Tia Assaad",
    authorRole: "Founder of Delitia",
    duration: "Inventory & P&L System",
    content:
      "When I needed a system to manage my bakery’s inventory and P&L, Tony was the immediate choice. He truly listens to your needs, pays attention to every detail, and delivers solutions that fit your business perfectly. What makes him stand out is his continuous support, always following up for feedback and improving the product to ensure the best experience possible.",
    displayOrder: 1,
  },
  {
    id: "juliana",
    authorName: "Juliana Moubarak",
    authorRole: "Data Management Analyst",
    duration: "1 Year Mentorship",
    content:
      "Tony was my mentor for an entire year while I completed a diploma in Machine Learning and Data Science. Although I had already been working in the data analysis field, this was my first hands-on experience with Python and Google Colab, and under Tony's guidance, they became clear, approachable, and easy to understand.\n\nThroughout the year, we covered topics ranging from analytics to deep learning and large language models. What truly set Tony apart, however, was not only his ability to explain complex course material, but the way he consistently connected concepts to real-life scenarios, making them practical and applicable.\n\nAs a brilliant software developer himself, Tony brings real-world experience into his teaching. His patience, technical expertise, and ability to tailor explanations to my questions made the learning process both effective and enjoyable. I highly recommend Tony as a mentor for anyone seeking strong technical guidance combined with real industry insight.",
    displayOrder: 2,
  },
  {
    id: "ndu-anon",
    authorName: "Anonymous Student",
    authorRole: "NDU Computer Science",
    duration: "University Course",
    content:
      "Tony is a dedicated instructor who explains concepts clearly, supports his students, and creates a motivating learning environment. His C++ course was the reason I stuck with computer science.",
    isAnonymous: true,
    displayOrder: 3,
  },
];
